module.exports = __webpack_public_path__ + "static/media/vanshika_turkar.9eb577c0.png";